import React from 'react';

const Filter = ({ label, id, options, value, onChange, style = {} }) => {
  return (
    <div className="filter-container" style={{ margin: '10px 0', ...style }}>
      <label htmlFor={id} style={{ marginRight: '8px' }}>{label}</label>
      <select
        id={id}
        value={value}
        onChange={onChange}
        style={{ padding: '4px 8px' }}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>{option.label}</option>
        ))}
      </select>
    </div>
  );
};

export default Filter;
